<div class="iframe-wrapper position-relative">
  <button class="close-btn position-absolute" mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <iframe class="iframe" [src]="iframeSrc" frameborder="0"></iframe>
</div>
